export default __webpack_public_path__ + "static/media/bow_draw.7d3cfd6b.mp3";